
import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleApplyClick = () => {
    if (location.pathname === '/') {
      const applicationFormTitle = document.querySelector('#application-form-title');
      if (applicationFormTitle) {
        const headerHeight = 80;
        const elementPosition = applicationFormTitle.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const applicationFormTitle = document.querySelector('#application-form-title');
        if (applicationFormTitle) {
          const headerHeight = 80;
          const elementPosition = applicationFormTitle.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerHeight;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 300);
    }
    setIsMenuOpen(false);
  };

  const scrollToApplication = () => {
    handleApplyClick();
  };

  const handleNavClick = (path: string) => {
    navigate(path);
    setIsMenuOpen(false);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  return (
    <header className="bg-white/95 backdrop-blur-md shadow-sm border-b border-rose-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <button 
              onClick={() => handleNavClick('/')}
              className="flex items-center space-x-4 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/4b22fec895be8868ec3e756cd14dfaa5/408757279e627d3a2d17ea65950b0beb.png"
                  alt="モニター友の会"
                  className="w-12 h-12 object-cover rounded-lg shadow-lg group-hover:shadow-xl transition-all duration-300"
                />
              </div>
              <div className="flex flex-col">
                <span className="text-2xl font-bold bg-gradient-to-r from-rose-500 to-pink-600 bg-clip-text text-transparent" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  モニター友の会
                </span>
                <span className="text-xs text-gray-500 -mt-1">Monitor Friends Club</span>
              </div>
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => handleNavClick('/')}
              className="text-gray-700 hover:text-rose-500 font-medium transition-colors cursor-pointer relative group"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              ホーム
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-rose-400 to-pink-500 group-hover:w-full transition-all duration-300"></span>
            </button>
            <button 
              onClick={() => handleNavClick('/product-types')}
              className="text-gray-700 hover:text-rose-500 font-medium transition-colors cursor-pointer relative group"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              体験商品の種類
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-rose-400 to-pink-500 group-hover:w-full transition-all duration-300"></span>
            </button>
            <button 
              onClick={() => handleNavClick('/monitor-flow')}
              className="text-gray-700 hover:text-rose-500 font-medium transition-colors cursor-pointer relative group"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              活動の流れ
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-rose-400 to-pink-500 group-hover:w-full transition-all duration-300"></span>
            </button>
            <button 
              onClick={() => handleNavClick('/faq')}
              className="text-gray-700 hover:text-rose-500 font-medium transition-colors cursor-pointer relative group"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              よくある質問
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-rose-400 to-pink-500 group-hover:w-full transition-all duration-300"></span>
            </button>
            <button
              onClick={scrollToApplication}
              className="bg-gradient-to-r from-rose-400 to-pink-500 hover:from-rose-500 hover:to-pink-600 text-white px-8 py-3 rounded-full font-bold transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:scale-105"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              <i className="ri-user-add-line mr-2"></i>
              参加申込み
            </button>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-rose-500 cursor-pointer p-2 rounded-full hover:bg-rose-50 transition-all duration-300"
            >
              <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-rose-100 py-6 rounded-b-2xl shadow-lg">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => handleNavClick('/')}
                className="text-gray-700 hover:text-rose-500 font-medium transition-colors cursor-pointer px-6 py-3 rounded-xl hover:bg-rose-50 text-left"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                <i className="ri-home-line mr-3"></i>
                ホーム
              </button>
              <button 
                onClick={() => handleNavClick('/product-types')}
                className="text-gray-700 hover:text-rose-500 font-medium transition-colors cursor-pointer px-6 py-3 rounded-xl hover:bg-rose-50 text-left"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                <i className="ri-gift-line mr-3"></i>
                体験商品の種類
              </button>
              <button 
                onClick={() => handleNavClick('/monitor-flow')}
                className="text-gray-700 hover:text-rose-500 font-medium transition-colors cursor-pointer px-6 py-3 rounded-xl hover:bg-rose-50 text-left"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                <i className="ri-flow-chart mr-3"></i>
                活動の流れ
              </button>
              <button 
                onClick={() => handleNavClick('/faq')}
                className="text-gray-700 hover:text-rose-500 font-medium transition-colors cursor-pointer px-6 py-3 rounded-xl hover:bg-rose-50 text-left"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                <i className="ri-question-line mr-3"></i>
                よくある質問
              </button>
              <button
                onClick={scrollToApplication}
                className="bg-gradient-to-r from-rose-400 to-pink-500 hover:from-rose-500 hover:to-pink-600 text-white px-8 py-4 rounded-full font-bold transition-all duration-300 cursor-pointer whitespace-nowrap mx-6 text-center shadow-lg"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                <i className="ri-user-add-line mr-2"></i>
                参加申込み
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
